import { NotificationScope } from "@/shared/common/enums";
import { useAppSelector, useNotify } from "@/shared/hooks";
import { Alert } from "@ab.uitools/ui-library/components/Alert";
import { useEffect } from "react";

interface Props {
  className?: string;
  scope?: string;
  canClose?: boolean;
}

export const Notification = ({
  className,
  canClose = true,
  scope = NotificationScope.Page,
}: Props) => {
  const { clearAlertNotification } = useNotify();
  const notification = useAppSelector(state => state.notification.alertNotification);

  const onClose = () => {
    clearAlertNotification();
  };

  useEffect(() => {
    return () => {
      onClose();
    };
  }, []);

  if (!notification?.message || notification.scope !== scope) {
    return null;
  }

  return (
    <Alert
      text={notification.message}
      type={notification.type}
      closeIcon={canClose}
      onClose={onClose}
      className={`notification ${className}`}
    />
  );
};
